<template lang="pug">
    div
        form(id="import-mapper")
            div.row-col.m-t-md 
                div.col-xs-6.p-a-sm
                    span._500.m-l-sm Planogram Quantity
                    span._500.m-l-sm.block(style="color: #1F9A92")  {{ uploadedContent.total_planogram }} Planograms will be added
                div.col-xs-6.p-a-sm
                    .form-group
                        span._500.m-l-sm Description
                        input.form-control(
                            v-validate="'required'",
                            v-model="planogram.description",
                            :disabled="onLoading(loader)",
                            type="text",
                            class="form-control",
                            name="description",
                            placeholder="Required",
                        )
            div.row-col.m-b-md
                div.col-xs-6.p-a-sm
                    span._500.m-l-sm Total Product Line
                    span._500.m-l-sm.block(style="color: #1F9A92")  {{ uploadedContent.total_rows }} lines will be insert
                div.col-xs-6.p-a-sm
                    span._500.m-l-sm Effective Date
                    datetimepicker-input( :disabled="onLoading(loader)", v-model="planogram.effectiveDate")
</template>

<script>
import { Event } from '../../../event-bus';
import DatetimepickerInput from '@js/components/datetimepicker/datetimepicker.vue';
import { mapState } from 'vuex';
export default {
    components: {
        DatetimepickerInput,
    },
    props: {
        uploadedContent: {
            type: Object,
            required: true,
        },
        importKey: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            attributes: [
                { key: 'planogram_name', name: 'Planogram Name', mapper: null },
                { key: 'segment_name', name: 'Segment Name', mapper: null },
                { key: 'sequence', name: 'Sequence', mapper: null },
                { key: 'facings', name: 'Facings', mapper: null },
                { key: 'barcode', name: 'Barcode', mapper: null },
                { key: 'descriptions', name: 'Descriptions', mapper: null },
                { key: 'size', name: 'Size', mapper: null },
                { key: 'uom', name: 'UOM', mapper: null },
            ],
        };
    },

    computed: {
        headings() {
            return this.uploadedContent.headings.filter(h => {
                return typeof h == 'string';
            });
        },

        rows() {
            return this.uploadedContent.rows;
        },

        ...mapState(['planogram']),

        mapper() {
            let mapper = {};

            this.attributes.forEach(attribute => {
                mapper[attribute.key] = attribute.mapper;
            });

            return mapper;
        },
        loader() {
            return 'importing planogram';
        },
    },

    mounted() {
        this.autoMappingColumn();
    },

    methods: {
        autoMappingColumn() {
            this.attributes.forEach((attr, idx) => {
                if (this.isHeadingsExists(attr.key)) {
                    attr.mapper = attr.key;
                }
            });
        },

        isHeadingsExists(heading) {
            return !_.isUndefined(this.headings.find(h => h == heading));
        },

        getSampleDataByKey(key) {
            if (_.isNull(key)) {
                return [];
            }

            return this.rows
                .filter(row => {
                    return !_.isNull(row[key]) && row[key] != '';
                })
                .map(row => row[key])
                .splice(0, 3);
        },

        submit() {
            this.startLoading(this.loader);

            let api = Laroute.route(
                'franchise.inventory.planogram.validate_data',
                {
                    importKey: this.importKey,
                },
            );

            axios
                .post(api, this.mapper)
                .then(res => {
                    Event.$emit('validating-data', this.mapper);
                })
                .catch(err => {
                    this.endLoading(this.loader);
                    this.showApiError(err);
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/planogram/import-planogram-mapper.vue